// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { ROUTE_PERMISSIONS } from "@/config/permissions";

import LoginView from "@/views/auth/LoginView.vue";
import DashboardView from "@/views/dashboard/DashboardView.vue";
import UnitListView from "@/views/units/UnitListView.vue";
import UnitDetailView from "@/views/units/UnitDetailView.vue";
import ResidentListView from "@/views/residents/ResidentListView.vue";
import ResidentDetailView from "@/views/residents/ResidentDetailView.vue";
import ResidentDashboardDetailView from "@/views/residents/ResidentDashboardDetailView.vue";
import InvoiceListView from "@/views/invoices/InvoiceListView.vue";
import InvoiceDetailView from "@/views/invoices/InvoiceDetailView.vue";
import PaymentListView from "@/views/payments/PaymentListView.vue";
import PaymentDetailView from "@/views/payments/PaymentDetailView.vue";
import PaymentFormView from "@/views/payments/PaymentFormView.vue";
import ArrearsListView from "@/views/arrears/ArrearsListView.vue";
import ReportsDashboardView from "@/views/reports/ReportsDashboardView.vue";
import UnauthorizedView from "@/views/errors/UnauthorizedView.vue";

const routes = [
  { path: "/", redirect: "/login" },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { guestOnly: true },
  },
  {
    path: "/unauthorized",
    name: "unauthorized",
    component: UnauthorizedView,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: "/units",
    name: "units",
    component: UnitListView,
    meta: { requiresAuth: true },
  },
  {
    path: "/units/:id",
    name: "unit-detail",
    component: UnitDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: "/residents",
    name: "residents",
    component: ResidentListView,
    meta: { requiresAuth: true },
  },
  {
    path: "/residents/:id",
    name: "resident-detail",
    component: ResidentDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: "/resident-detail/:id",
    name: "resident-my-detail",
    component: ResidentDashboardDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: "/invoices",
    name: "invoices",
    component: InvoiceListView,
    meta: { requiresAuth: true },
  },
  {
    path: "/invoices/:id",
    name: "invoice-detail",
    component: InvoiceDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: "/payments",
    name: "payments",
    component: PaymentListView,
    meta: { requiresAuth: true },
  },
  {
    path: "/payments/create",
    name: "payment-create",
    component: PaymentFormView,
    meta: { requiresAuth: true },
  },
  {
    path: "/payments/:id",
    name: "payment-detail",
    component: PaymentDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: "/arrears",
    name: "arrears",
    component: ArrearsListView,
    meta: { requiresAuth: true },
  },
  {
    path: "/reports",
    name: "reports",
    component: ReportsDashboardView,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("cm_token");
  const userRaw = localStorage.getItem("cm_user");
  const user = userRaw ? JSON.parse(userRaw) : null;

  // ยังไม่ login → ไป login
  if (to.meta.requiresAuth && !token) {
    next("/login");
    return;
  }

  // login แล้วแต่เข้าหน้า guest-only → ไป dashboard
  if (to.meta.guestOnly && token) {
    next("/dashboard");
    return;
  }

  // ✅ ตรวจสิทธิ์ตาม role
  if (to.meta.requiresAuth && user?.role) {
    const allowedRoles = ROUTE_PERMISSIONS[to.name];

    // ถ้า route นั้นกำหนด roles ไว้ และ role ของ user ไม่อยู่ในลิสต์
    if (allowedRoles && !allowedRoles.includes(user.role)) {
      next("/unauthorized");
      return;
    }
  }

  next();
});

export default router;
